const langtrans={
      gywmm:["关于我们","About us"],
      xwzzx:["新闻中心","Press Center"],
      qqjylm:["全球救援联盟","Global Assistance Service Alliance"],
      xssffw:["星使服务","Xingshi service"],
      ffqbbl:["全球救援联盟于2016年创立，是由江泰救援服务有限公司（以下简称江泰救援）发起，并联合了全球知名的救援企业、航空公司、安保公司、律师事务所、旅行社等企业团体组织成立的，为中国公民提供全球范围救援服务的组织。江泰救援作为中国公民全球救援指挥中心，每年为联盟成员提供全球233个国家地区范围内的有关救援、安保、医疗、转运、旅游服务、财产安全等全救援链上的国人需求。加入我们，共建全球安保救援生态，服务更多出行国人。","the universal Assistance alliance combines with well-known Assistance enterprises, airline company, security company, law firm, travelling agency and enterprise groups to provide Chinese with worldwide Assistance services. Jiangtai Assistance serves as the command center of global Assistance for Chinese and its Assistance scopes for its members reach up to 233 countries and regions, covering Assistance, security, medical treatment, transferring, travelling service, property safety, etc. Join us and jointly build universal Assistance system to serve more Chinese travelers."],
      bcgggx:["秉持“共享共赢”宗旨，全球救援联盟每个成员可以享受：","Adhering to “Sharing and Win-win”, each member in universal Assistance alliance is entitled to the following privileges:"],
      jrzzgz:["加入中国走出去发展的大机遇","Grasp the opportunity of China Going Abroad"],
      hdddqq:["获得全球范围内更多出行国人的救援需求","Obtain the Assistance demands from more Chinese travelling overseas"],
      ytlmmp:["依托联盟平台，相互委托，达成更多合作","Reach more cooperation relying on alliance platform"],
      mnjxhh:["每年举行联盟年会，共享资源与信息","Share resources and information on annual meeting"],
      ljjrqq:["立即加入全球救援","Join us"],
      ffwsjm:["服务商加盟","Becoming a service provider"],
      gsmccc:["公司名称","Company name"],
      srgsmc:["输入公司名称","Please type your Company name"],
      ffwlx:["服务类型","Service type"],
      srgsff:["输入公司服务类型","Please type your Service type"],
      gjgjj:["国家","en_translated"],
      srgssf:["输入公司所服务的国家","Please type your Country"],
      lxjrxm:["联系人姓名","en_translated"],
      srgslx:["输入公司联系人","Please type your Contact name"],
      dh:["电话","Tel"],
      srlxjr:["输入联系人电话","Please type your Tel"],
      yx:["邮箱","en_translated"],
      srgsyx:["输入公司邮箱","Please type your Company name"],
      xsxx:["信息","Message"],
      tdsjxs:["提交信息","Submit"],
      nycgtd:["您已成功提交信息","You have submitted your feedback"],
      jyjgdl:["救援机构登录成功","Your login Assistance organization is successful"],
      jjgjgd:["监管机构登录成功","en_translated"],
      zzzhzz:["指挥中心登录成功","en_translated"],
      dlsbgy:["登录失败，该用户不属于监管机构","en_translated"],
      dlsbyh:["登录失败，用户名或密码错误","Your login failed for incorrect user name or password"],
      dlsbwz:["登录失败，未知错误","Your login failed for unknown reason"],
}
export default langtrans;


// WEBPACK FOOTER //
// ./src/assets/languagejs/league.vue.trans.js